import { useSectionTranslation } from '@/hooks';
import { paymentMethodsTranslations } from './translations';

/**
 * Real brand marks downloaded by `scripts/fetch_category_logos.py --payments`
 * into `public/payments/`. The previous build rendered the lucide `Bitcoin`
 * glyph three times — once per "method" — so LTC and USDT were literally
 * Bitcoin logos.
 */
const methods = [
  { key: 'btc', src: '/payments/btc.svg', alt: 'Bitcoin' },
  { key: 'ltc', src: '/payments/ltc.svg', alt: 'Litecoin' },
  { key: 'usdt', src: '/payments/usdt.svg', alt: 'Tether (USDT)' },
  { key: 'visa', src: '/payments/visa.svg', alt: 'Visa' },
  { key: 'mastercard', src: '/payments/mastercard.svg', alt: 'Mastercard' },
] as const;

export function PaymentMethods() {
  const t = useSectionTranslation(paymentMethodsTranslations);

  return (
    <section className="py-8 border-t border-surface-border" aria-label={t.label}>
      <div className="container-main flex flex-col items-center gap-4">
        <span className="text-[11px] font-semibold uppercase tracking-widest text-brand-muted">
          {t.label}
        </span>
        <ul className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3">
          {methods.map(({ key, src, alt }) => (
            <li key={key} className="flex items-center gap-2">
              <img
                src={src}
                alt={alt}
                loading="lazy"
                className="h-5 w-auto max-w-[92px] object-contain opacity-80 transition-opacity hover:opacity-100"
              />
              <span className="text-xs font-medium text-brand-muted">
                {t.methods[key]}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}